// Indian States and Cities Data for Property Search
export const INDIAN_STATES = [
  { value: "maharashtra", label: "Maharashtra" },
  { value: "karnataka", label: "Karnataka" },
  { value: "tamil_nadu", label: "Tamil Nadu" },
  { value: "delhi", label: "Delhi" },
  { value: "uttar_pradesh", label: "Uttar Pradesh" },
  { value: "gujarat", label: "Gujarat" },
  { value: "rajasthan", label: "Rajasthan" },
  { value: "west_bengal", label: "West Bengal" },
  { value: "telangana", label: "Telangana" },
  { value: "andhra_pradesh", label: "Andhra Pradesh" },
  { value: "kerala", label: "Kerala" },
  { value: "madhya_pradesh", label: "Madhya Pradesh" },
  { value: "punjab", label: "Punjab" },
  { value: "haryana", label: "Haryana" },
  { value: "bihar", label: "Bihar" },
  { value: "odisha", label: "Odisha" },
  { value: "jharkhand", label: "Jharkhand" },
  { value: "chhattisgarh", label: "Chhattisgarh" },
  { value: "assam", label: "Assam" },
  { value: "goa", label: "Goa" },
  { value: "uttarakhand", label: "Uttarakhand" },
  { value: "himachal_pradesh", label: "Himachal Pradesh" },
  { value: "jammu_kashmir", label: "Jammu & Kashmir" },
  { value: "chandigarh", label: "Chandigarh" },
];

export const CITIES_BY_STATE = {
  maharashtra: [
    { value: "mumbai", label: "Mumbai" },
    { value: "pune", label: "Pune" },
    { value: "nagpur", label: "Nagpur" },
    { value: "thane", label: "Thane" },
    { value: "nashik", label: "Nashik" },
    { value: "aurangabad", label: "Aurangabad" },
    { value: "solapur", label: "Solapur" },
    { value: "kolhapur", label: "Kolhapur" },
    { value: "navi_mumbai", label: "Navi Mumbai" },
    { value: "pimpri_chinchwad", label: "Pimpri-Chinchwad" },
  ],
  karnataka: [
    { value: "bangalore", label: "Bangalore" },
    { value: "mysore", label: "Mysore" },
    { value: "mangalore", label: "Mangalore" },
    { value: "hubli", label: "Hubli-Dharwad" },
    { value: "belgaum", label: "Belgaum" },
    { value: "gulbarga", label: "Gulbarga" },
  ],
  tamil_nadu: [
    { value: "chennai", label: "Chennai" },
    { value: "coimbatore", label: "Coimbatore" },
    { value: "madurai", label: "Madurai" },
    { value: "tiruchirappalli", label: "Tiruchirappalli" },
    { value: "salem", label: "Salem" },
    { value: "tirunelveli", label: "Tirunelveli" },
  ],
  delhi: [
    { value: "new_delhi", label: "New Delhi" },
    { value: "central_delhi", label: "Central Delhi" },
    { value: "south_delhi", label: "South Delhi" },
    { value: "north_delhi", label: "North Delhi" },
    { value: "east_delhi", label: "East Delhi" },
    { value: "west_delhi", label: "West Delhi" },
    { value: "dwarka", label: "Dwarka" },
    { value: "rohini", label: "Rohini" },
  ],
  uttar_pradesh: [
    { value: "lucknow", label: "Lucknow" },
    { value: "noida", label: "Noida" },
    { value: "ghaziabad", label: "Ghaziabad" },
    { value: "kanpur", label: "Kanpur" },
    { value: "agra", label: "Agra" },
    { value: "varanasi", label: "Varanasi" },
    { value: "greater_noida", label: "Greater Noida" },
    { value: "prayagraj", label: "Prayagraj" },
  ],
  gujarat: [
    { value: "ahmedabad", label: "Ahmedabad" },
    { value: "surat", label: "Surat" },
    { value: "vadodara", label: "Vadodara" },
    { value: "rajkot", label: "Rajkot" },
    { value: "gandhinagar", label: "Gandhinagar" },
    { value: "bhavnagar", label: "Bhavnagar" },
  ],
  rajasthan: [
    { value: "jaipur", label: "Jaipur" },
    { value: "jodhpur", label: "Jodhpur" },
    { value: "udaipur", label: "Udaipur" },
    { value: "kota", label: "Kota" },
    { value: "ajmer", label: "Ajmer" },
    { value: "bikaner", label: "Bikaner" },
  ],
  west_bengal: [
    { value: "kolkata", label: "Kolkata" },
    { value: "howrah", label: "Howrah" },
    { value: "durgapur", label: "Durgapur" },
    { value: "siliguri", label: "Siliguri" },
    { value: "asansol", label: "Asansol" },
  ],
  telangana: [
    { value: "hyderabad", label: "Hyderabad" },
    { value: "secunderabad", label: "Secunderabad" },
    { value: "warangal", label: "Warangal" },
    { value: "nizamabad", label: "Nizamabad" },
    { value: "karimnagar", label: "Karimnagar" },
  ],
  andhra_pradesh: [
    { value: "visakhapatnam", label: "Visakhapatnam" },
    { value: "vijayawada", label: "Vijayawada" },
    { value: "guntur", label: "Guntur" },
    { value: "tirupati", label: "Tirupati" },
    { value: "nellore", label: "Nellore" },
    { value: "amaravati", label: "Amaravati" },
  ],
  kerala: [
    { value: "kochi", label: "Kochi" },
    { value: "thiruvananthapuram", label: "Thiruvananthapuram" },
    { value: "kozhikode", label: "Kozhikode" },
    { value: "thrissur", label: "Thrissur" },
    { value: "kollam", label: "Kollam" },
  ],
  madhya_pradesh: [
    { value: "bhopal", label: "Bhopal" },
    { value: "indore", label: "Indore" },
    { value: "jabalpur", label: "Jabalpur" },
    { value: "gwalior", label: "Gwalior" },
    { value: "ujjain", label: "Ujjain" },
  ],
  punjab: [
    { value: "ludhiana", label: "Ludhiana" },
    { value: "amritsar", label: "Amritsar" },
    { value: "jalandhar", label: "Jalandhar" },
    { value: "patiala", label: "Patiala" },
    { value: "mohali", label: "Mohali" },
  ],
  haryana: [
    { value: "gurgaon", label: "Gurgaon" },
    { value: "faridabad", label: "Faridabad" },
    { value: "panipat", label: "Panipat" },
    { value: "ambala", label: "Ambala" },
    { value: "karnal", label: "Karnal" },
    { value: "sonipat", label: "Sonipat" },
  ],
  bihar: [
    { value: "patna", label: "Patna" },
    { value: "gaya", label: "Gaya" },
    { value: "muzaffarpur", label: "Muzaffarpur" },
    { value: "bhagalpur", label: "Bhagalpur" },
  ],
  odisha: [
    { value: "bhubaneswar", label: "Bhubaneswar" },
    { value: "cuttack", label: "Cuttack" },
    { value: "rourkela", label: "Rourkela" },
  ],
  jharkhand: [
    { value: "ranchi", label: "Ranchi" },
    { value: "jamshedpur", label: "Jamshedpur" },
    { value: "dhanbad", label: "Dhanbad" },
  ],
  chhattisgarh: [
    { value: "raipur", label: "Raipur" },
    { value: "bhilai", label: "Bhilai" },
    { value: "bilaspur", label: "Bilaspur" },
  ],
  assam: [
    { value: "guwahati", label: "Guwahati" },
    { value: "silchar", label: "Silchar" },
    { value: "dibrugarh", label: "Dibrugarh" },
  ],
  goa: [
    { value: "panaji", label: "Panaji" },
    { value: "margao", label: "Margao" },
    { value: "vasco", label: "Vasco da Gama" },
    { value: "mapusa", label: "Mapusa" },
  ],
  uttarakhand: [
    { value: "dehradun", label: "Dehradun" },
    { value: "haridwar", label: "Haridwar" },
    { value: "rishikesh", label: "Rishikesh" },
    { value: "nainital", label: "Nainital" },
  ],
  himachal_pradesh: [
    { value: "shimla", label: "Shimla" },
    { value: "dharamshala", label: "Dharamshala" },
    { value: "manali", label: "Manali" },
    { value: "solan", label: "Solan" },
  ],
  jammu_kashmir: [
    { value: "srinagar", label: "Srinagar" },
    { value: "jammu", label: "Jammu" },
  ],
  chandigarh: [
    { value: "chandigarh", label: "Chandigarh" },
  ],
};

// Possession Status Options
export const POSSESSION_STATUS_OPTIONS = [
  { value: "ready_to_move", label: "Ready to Move" },
  { value: "under_construction", label: "Under Construction" },
  { value: "new_launch", label: "New Launch" },
];

// Furnishing Status Options
export const FURNISHING_OPTIONS = [
  { value: "furnished", label: "Fully Furnished" },
  { value: "semi_furnished", label: "Semi-Furnished" },
  { value: "unfurnished", label: "Unfurnished" },
];

// RERA Options
export const RERA_OPTIONS = [
  { value: "yes", label: "RERA Approved" },
  { value: "no", label: "Not RERA Approved" },
  { value: "all", label: "All" },
];

// Get city label from value
export const getCityLabel = (state, cityValue) => {
  const cities = CITIES_BY_STATE[state] || [];
  const city = cities.find(c => c.value === cityValue);
  return city ? city.label : cityValue;
};

// Get state label from value
export const getStateLabel = (stateValue) => {
  const state = INDIAN_STATES.find(s => s.value === stateValue);
  return state ? state.label : stateValue;
};

// Check if a location exists in multiple cities
export const findLocationInCities = (location, allProperties) => {
  if (!location) return [];
  
  const locationLower = location.toLowerCase();
  const matchingCities = new Set();
  
  allProperties.forEach(prop => {
    if (prop.location && prop.location.toLowerCase().includes(locationLower)) {
      if (prop.city) {
        matchingCities.add(JSON.stringify({ city: prop.city, state: prop.state }));
      }
    }
  });
  
  return Array.from(matchingCities).map(item => JSON.parse(item));
};
